module.exports = __webpack_public_path__ + "assets/img/logo.dd6e60a6.png";